import { UserRole } from "./../types/userrole.type";

import axios from "./api";

/**
 *
 * @returns
 */
export const getUserRole = (): Promise<UserRole[]> => {
  return axios
    .get<UserRole[]>(`/userrole/`)
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      throw new Error(res.status.toString());
    })
    .catch((res) => {
      throw new Error(res.status);
    });
};
